import React, { FC, PropsWithChildren } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';

export interface HeaderRightSideProps extends PropsWithChildren {
  containerStyles?: StyleProp<ViewStyle>;
}

const HeaderRightSide: FC<HeaderRightSideProps> = ({ children, containerStyles }) => {
  const { scale } = useOperatorPanelSettingsWrapperContext();

  return (
    <View
      style={[
        {
          flexDirection: 'row',
          alignItems: 'center',
          gap: scale(8),
          flexShrink: 1,
        },
        containerStyles,
      ]}
    >
      {children}
    </View>
  );
};

export default HeaderRightSide;
